module.exports = __webpack_public_path__ + "static/media/lacoste.7ce8aaf6.svg";